import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function LeadershipPartnershipOverview() {
  return <section data-section-id="4070" id="hero" className="relative bg-background text-foreground overflow-hidden py-24 lg:py-32 flex flex-col items-center justify-center text-center">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-5" style={{
      backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px),
                            linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} aria-hidden="true" />

      {}
      <div className="relative z-10 container px-4 mx-auto flex flex-col items-center">
        <h1 className="font-serif font-bold text-4xl lg:text-5xl text-accent mb-4 animate-fade-in-up leading-tight tracking-tight">
          Chiropractor in Nicosia
        </h1>

        <h2 className="font-serif font-bold text-3xl lg:text-5xl text-primary mb-6 animate-fade-in-up leading-tight tracking-tight">
          Expert Chiropractic Care in Cyprus
        </h2>

        <p className="font-sans text-xl text-muted-foreground max-w-[40rem] mb-8 animate-fade-in-up-delay-100 leading-relaxed">
          Restoring your body's natural alignment and vitality through specialized chiropractic treatments in Limassol and Nicosia.
        </p>

        <div className="animate-fade-in-up-delay-200">
          <Button asChild className="bg-primary text-primary-foreground hover:opacity-90 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 px-8 py-6 text-lg h-auto font-semibold">
            <Link to="/ContactPage">
              Book Your Consultation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}